export default __webpack_public_path__ + "static/media/USDT.e.7169edf4.png";